(function () {
	'use strict';

	/**
	 * @ngdoc component
	 * @name mx.agent:mxObjectLink
	 * @module mx.agent
	 * @description Displays related object
	 * @param {string} label@ - Optional. Label of the control.
	 * @param {string} entityClassName@ - SPS class where data should be loaded from.
	 * @param {value} object= - Reference to the Entity object
	 * @param {idType} enum= - Indicates whether ObjectId or ClassId used in getting data
	 */
	angular.module('mx.SolutionBuilderAgent').component('mxObjectLink', {
		require: {
			mxFormCtrl: '?^mxForm',
			parentViewController: '?^^mxView',
		},
		bindings: {
			value: '<',
			valueLabel: '@',
			label: '@',
			icon: '@',
			parentExpression: '@',
			hideOnEmptyValue: '@',
			reserveIconSpace: '@',
			entityClassName: '@',
			displayExpression: '@',
			dataQuery: '@query',
			labelPosition: '@',
			valueMinWidth: '@',
			labelMinWidth: '@',
			labelMaxWidth: '@',
			valueColor: '@',
			labelColor: '@',
			iconColor: '@',
			idType: '@?',
			designerMode: '<?',
			rootElement: '@?',
		},
		controller: MxObjectLiteralCtrl,
		controllerAs: 'vm',
		template: [
			'$attrs',
			function (tAttrs) {
				var optmzr = typeof tAttrs.designerMode !== 'undefined' && ('' + tAttrs.designerMode).toLowerCase() !== 'false' ? '' : '::';
				return `<mx-literal
						label="{{${optmzr}vm.label}}"
						type="link"
						value="${optmzr}vm.literalValue"
						icon="{{::vm.icon}}"
						hide-on-empty-value="{{::vm.hideOnEmptyValue}}"
						reserve-icon-space="{{::vm.reserveIconSpace}}"
						label-position="{{::vm.labelPosition}}"
						value-min-width="{{::vm.valueMinWidth}}"
						label-min-width="{{::vm.labelMinWidth}}"
						label-max-width="{{::vm.labelMaxWidth}}"
						value-color="{{::vm.valueColor}}"
						label-color="{{::vm.labelColor}}"
						icon-color="{{::vm.iconColor}}"
						${typeof tAttrs.designerMode !== 'undefined' ? 'designer-mode="' + tAttrs.designerMode + '" ' : ''}
					></mx-literal>`;
			},
		],
	});

	MxObjectLiteralCtrl.$inject = [
		'mx.SolutionBuilderAgent.EntityService',
		'mx.SolutionBuilderAgent.DialogOpenerService',
		'mx.SolutionBuilderAgent.mxColumnDefinitionService',
		'mx.SolutionBuilderAgent.ContentWidgetService',
		'$q',
		'$element',
		'$scope',
		'$timeout',
	];

	function MxObjectLiteralCtrl(mxEntityService, dialogOpener, columnDefinition, contentWidgetService, $q, $element, $scope, $timeout) {
		var vm = this;
		var widgetId;
		var _value;

		vm.$onInit = function () {
			_value = vm.value;

			Object.defineProperty(vm, 'value', {
				get: function () {
					return _value;
				},
				set: setValue,
			});

			vm.hideOnEmptyValueProcessed = vm.hideOnEmptyValue === 'true';
			$element.addClass('with-value');

			setValue(_value);

			widgetId = contentWidgetService.getWidgetIdForControl(this, $scope);
		};

		vm.$postLink = function () {
			$element.addClass('mx-literal');
		};

		function onClick() {
			if (!vm.objDetails) {
				if (_value._type && _value._id) {
					vm.objDetails = {
						EntityType: _value._type,
						Id: _value._id,
					};
				} else if (_value.Id && _value.EntityType) {
					vm.objDetails = _value;
				} else if (_value.$item && _value.$item.Id && _value.$item.EntityType) {
					vm.objDetails = _value.$item;
				}
			}

			$q(function (resolve) {
				if (vm.objDetails) {
					resolve(vm.objDetails);
				} else {
					return getFragmentDescriptorsInBatch(
						vm.entityClassName,
						_value.Id || _value.Value || _value,
						undefined,
						vm.idType === 'object',
						undefined,
						undefined,
						undefined,
						vm.dataQuery
					).then(function (objDetails) {
						vm.objDetails = objDetails;
						resolve(vm.objDetails);
					});
				}
			}).then(function (objDetails) {
				return dialogOpener.openPreview(objDetails, undefined, undefined, vm.parentViewController && vm.parentViewController.mxView);
			});
		}

		function setValue(value) {
			_value = value;
			if (vm.hideOnEmptyValueProcessed) {
				if (_value) {
					$element.addClass('with-value');
				} else {
					$element.removeClass('with-value');
				}
			}
			vm.objDetails = null;
			vm.hasViews = undefined;
			if (_value) {
				if (typeof _value === 'object' && !_value.Id && !_value.Value) {
					_value = null;
					return;
				}

				vm.literalValue = {};
				if (vm.entityClassName || _value.EntityType || _value._type) {
					vm.literalValue.onClick = onClick;
				}
				if (vm.valueLabel) {
					vm.literalValue.text = vm.valueLabel;
				}
			} else if (value === null) {
				vm.literalValue = null;
			} else {
				vm.literalValue = undefined;
			}
			$timeout(function () {
				setDisplayStrings((vm.mxFormCtrl && vm.mxFormCtrl.displayStrings) || null);
			});
		}

		function getObjectInfo() {
			var isService = false;

			return (
				!vm.entityClassName && vm.dataQuery
					? columnDefinition.getGridDefinitionByName(vm.dataQuery).then(function (columnDef) {
							if (columnDef.SchemaClassName) {
								vm.entityClassName = columnDef.SchemaClassName;
							} else {
								isService = true;
								vm.entityClassName = 'service_' + columnDef.Service;
								return mxEntityService.getObjectInfo('service_' + columnDef.Service, _value.Id || _value.Value || _value);
							}
					  })
					: $q.when()
			)
				.then(function (objDetails) {
					if (isService) {
						return objDetails;
					}
					if (vm.entityClassName) {
						return getFragmentDescriptorsInBatch(
							vm.entityClassName,
							_value.Id || _value.Value || _value,
							vm.parentExpression,
							vm.idType === 'object',
							vm.rootElement,
							true,
							vm.displayExpression,
							vm.dataQuery
						);
					}
				})
				.then(function (objDetails) {
					if (vm.parentExpression) {
						vm.objDetails = null;
					}
					if (!objDetails) {
						return;
					}
					vm.objDetails = objDetails;
					if (vm.literalValue) {
						vm.literalValue.onClick = onClick;
					} else {
						vm.literalValue = {};
					}

					vm.literalValue.text = objDetails.ParentDisplayString ? objDetails.ParentDisplayString + ' > ' + vm.objDetails.DisplayString : vm.objDetails.DisplayString;
				});
		}

		function setDisplayStrings(displayStrings) {
			if (vm.literalValue && !vm.literalValue.text) {
				var displayString = _value._displayName ? _value._displayName : _value.DisplayString ? _value.DisplayString : _value.DisplayValue;

				if (!displayString) {
					if (displayStrings === null || vm.displayExpression || vm.parentExpression) {
						//Check vm.parentExpression to ignore displaystrings for hierarchical link
						getObjectInfo();
					} else if (displayStrings) {
						var result = displayStrings.filter(function (item) {
							return item.Id === vm.value;
						});

						if (result.length === 1) {
							displayString = result[0].DisplayString;
						} else if (!result.length) {
							getObjectInfo();
						}
					}
				}

				if (displayString) {
					vm.literalValue.text = displayString;
				}
			}
		}

		function getFragmentDescriptorsInBatch(entityClassName, id, parentExpression, useObjectId, rootElement, includeRoot, displayExpression, dataQueryName) {
			return mxEntityService.getFragmentDescriptorsInBatch(
				entityClassName,
				id,
				parentExpression,
				useObjectId,
				rootElement,
				includeRoot,
				widgetId,
				displayExpression,
				dataQueryName
			);
		}
	}
})();
